module.exports = __webpack_public_path__ + "static/media/success.d900b173.gif";